import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    LyfisPersistedTraceDetailResponse,
    LyfisService,
} from '../../../services/lyfis.service';

@Component({
    selector: 'app-lyfis-persisted-trace-detail',
    templateUrl: './lyfis-persisted-trace-detail.component.html',
})
export class LyfisPersistedTraceDetailComponent {
    loading = false;
    data: LyfisPersistedTraceDetailResponse | null = null;

    get matchedQuestionnaireRows() {
        return (this.data?.traceDisplay.questionnaireBreakdown || []).filter(
            (row) => row.matched,
        );
    }

    get unmatchedQuestionnaireRows() {
        return (this.data?.traceDisplay.questionnaireBreakdown || []).filter(
            (row) => !row.matched,
        );
    }

    get matchedLabRows() {
        return (this.data?.traceDisplay.labBreakdown || []).filter(
            (row) => row.available && row.matched,
        );
    }

    get availableButUnmatchedLabRows() {
        return (this.data?.traceDisplay.labBreakdown || []).filter(
            (row) => row.available && !row.matched,
        );
    }

    get notAvailableLabRows() {
        return (this.data?.traceDisplay.labBreakdown || []).filter(
            (row) => !row.available,
        );
    }

    getTotalPoints(rows: Array<{ pointsAwarded: number }>) {
        return rows.reduce((sum, row) => sum + (row.pointsAwarded || 0), 0);
    }

    constructor(
        private route: ActivatedRoute,
        private lyfisService: LyfisService,
    ) {
        const snapshotId = this.route.snapshot.paramMap.get('snapshotId') || '';
        const diseaseScoreId = this.route.snapshot.paramMap.get('diseaseScoreId') || '';
        if (snapshotId && diseaseScoreId) {
            this.loading = true;
            this.lyfisService
                .getLyfisPersistedTraceDetail(snapshotId, diseaseScoreId)
                .toPromise()
                .then((res) => {
                    this.data = res || null;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
